export default "__VITE_ASSET__9b202575__"